<template>
  <div class='table-responsive text-nowrap'>
    <a-table
      :columns='columns'
      :row-key='data.id'
      :data-source='data'
      :pagination="false"
      :loading='loading'
    >
      <template #action='{text}'>
        <a-button
          @click="$emit('openModal', text)"
          class="btn btn-sm btn-light mr-2"
        >
          <i class="fe fe-edit mr-2" />
          Editar
        </a-button>
        <a-button
          @click="$emit('softDelete', text)"
          class="btn btn-sm btn-outline-danger mr-2"
        >
          <i class="fe fe-trash mr-2" />
          Eliminar
        </a-button>
      </template>
      <template #legend='{text}'>
        <span v-if="text === 'Recomendación'">
          Recomendación
        </span>
        <span v-else>
          Nota
        </span>
      </template>
      <template #activeRecord='{text}'>
        <i
          v-if="text === true"
          class="fe fe-check-circle mr-2 text-success"
        />
        <i
          v-else
          class="fe fe-x-circle mr-2 text-danger"
        />
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: 'No. de Orden ',
    dataIndex: 'order',
    class: 'text-center',
  },
  {
    title: 'Nombre de Leyenda',
    dataIndex: 'name',
    class: 'text-center',
  },
  {
    title: 'Tipo de Leyenda',
    dataIndex: 'type',
    slots: { customRender: 'legend' },
    class: 'text-center',
  },
  {
    title: 'Estatus',
    dataIndex: 'activeRecord',
    slots: { customRender: 'activeRecord' },
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: 'ConsignmentSettingsTable',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  emits: [
    'openModal', 'softDelete',
  ],
  setup() {
    return {
      columns,
    }
  },
}
</script>

<style scoped>
</style>
